import React, { Component } from "react";

import { BrowserRouter as Router, Route } from 'react-router-dom';

import withAuthentication from 'components/withAuthentication/withAuthentication';

import Header from "components/Header/Header.jsx";
import Navigation from "components/Header/Navigation.jsx";

import "assets/scss/material-kit-react.css";

import LandingPage from "views/LandingPage/LandingPage.jsx";
import ServicesPage from "views/ServicesPage/ServicesPage.jsx";
import ProjectPage from "views/ProjectPage/ProjectPage.jsx";
import ProjectJoinPage from "views/ProjectJoinPage/ProjectJoinPage.jsx";
import ProjectLoginPage from "views/ProjectLoginPage/ProjectLoginPage.jsx";
import MyStoryPage from "views/MyStoryPage/MyStoryPage.jsx";


class App extends Component {
		  render() {
		  	return (
			<Router basename={process.env.PUBLIC_URL}>
		    	<div>
			    	<Header
			          rightLinks={<Navigation />}
			          fixed
			          color="transparent"
			          changeColorOnScroll={{
			            height: 400,
			            color: "dark"
			          }}
			        />
			      	<Route exact path={'/'} component={LandingPage} />
      				<Route exact path={'/mystory'} component={MyStoryPage} />
      				<Route exact path={'/services'} component={ServicesPage} />
      				<Route exact path={'/projectsea'} component={ProjectPage} />
      				<Route exact path={'/projectlogin'} component={ProjectLoginPage} />
      				<Route exact path={'/projectjoin'} component={ProjectJoinPage} />
		      	</div>
		  	</Router>
		);
	}
}

export default withAuthentication(App);


// WEBPACK FOOTER //
// ./src/App.js